import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import api from '../lib/api';
import { Check, Loader2, XCircle, Trophy } from 'lucide-react';

export default function PaymentSuccessPage() {
  const [searchParams] = useSearchParams();
  const paymentIntentId = searchParams.get('payment_intent');
  const [status, setStatus] = useState('polling');
  const [data, setData] = useState(null);
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    if (!paymentIntentId) { setStatus('error'); return; }

    const poll = async () => {
      try {
        const res = await api.get(`/stripe/checkout/status/${paymentIntentId}`);
        setData(res.data);
        if (res.data.payment_status === 'paid') {
          setStatus('success');
          return;
        }
        if (attempts < 10) {
          setTimeout(() => setAttempts(a => a + 1), 2000);
        } else {
          setStatus('timeout');
        }
      } catch {
        setStatus('error');
      }
    };
    poll();
  }, [paymentIntentId, attempts]);

  const tournamentId = data?.metadata?.tournament_id;

  return (
    <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center p-6" data-testid="payment-success-page">
      <div className="max-w-md w-full text-center">
        {status === 'polling' && (
          <>
            <Loader2 className="w-16 h-16 text-[#FF6B35] mx-auto animate-spin mb-4" />
            <h1 className="text-2xl font-bold text-white mb-2">Vérification du paiement...</h1>
            <p className="text-[#888]">Un instant, nous confirmons votre inscription.</p>
          </>
        )}
        {status === 'success' && (
          <>
            <div className="w-20 h-20 mx-auto mb-4 rounded-full bg-green-500/10 flex items-center justify-center">
              <Check className="w-10 h-10 text-green-400" />
            </div>
            <h1 className="text-2xl font-bold text-white mb-2">Inscription confirmée !</h1>
            <p className="text-[#888] mb-1">Votre paiement de {((data?.amount_total || 0) / 100).toFixed(2)}€ a été accepté.</p>
            <p className="text-[#888] mb-6">Vous êtes inscrit au tournoi <strong className="text-white">{data?.metadata?.tournament_name}</strong></p>
            <div className="flex flex-col gap-3">
              {tournamentId && (
                <Link to={`/player/event/tournament/${tournamentId}`}
                  className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-xl bg-[#FF6B35] text-white font-medium hover:bg-[#E55A25] transition-colors">
                  <Trophy className="w-4 h-4" /> Voir le tournoi
                </Link>
              )}
              <Link to="/" className="text-[#888] text-sm hover:text-white transition-colors">Retour à l'accueil</Link>
            </div>
          </>
        )}
        {(status === 'error' || status === 'expired' || status === 'timeout') && (
          <>
            <div className="w-20 h-20 mx-auto mb-4 rounded-full bg-red-500/10 flex items-center justify-center">
              <XCircle className="w-10 h-10 text-red-400" />
            </div>
            <h1 className="text-2xl font-bold text-white mb-2">Erreur de paiement</h1>
            <p className="text-[#888] mb-6">Une erreur est survenue. Contactez le support si le problème persiste.</p>
            <Link to="/" className="inline-flex items-center justify-center px-6 py-3 rounded-xl bg-[#252525] text-white font-medium hover:bg-[#333] transition-colors">
              Retour à l'accueil
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
